import { Component } from '@angular/core'

@Component({
	selector: 'app-system-forgot-password-page',
	templateUrl: './forgot-password.component.html',
})
export class ForgotPasswordPage {}
